<meta charset="utf-8">

<h4>Competiciones</h4>

<div id="loading" *ngIf="loading">
    <img src="assets/imgs/spinner.gif" width="100%"/>
</div>

<div>
	<p class="text-nowrap">
	
	    <select id="competicion" name="competicion" class="form-control d-inline" style="width: 90%;" (change)="selectCompeticionChangeHandler($event)">
	       <option value=""> Seleccione una competición...</option>
	       <option [value]="competicion.id" *ngFor="let competicion of competiciones">{{competicion.descripcion}}</option>
	    </select>
	    <img id="imgFavorite" alt="seleccionado" src="/assets/imgs/ic_estrella_unselected.png" width="16" height="16" style="margin-left: 5px;"
	       (click)="selectFavoriteCompeticion()"/>
	</p>
	
	<p>
	    <select id="opcion" name="opcion" class="form-control" (change)="selectOpcionChangeHandler($event)">
	       <option value="1">PARTIDOS</option>
	       <option value="2">CLASIFICACIÓN</option>
	    </select>
	</p>
	
	<!--  -->
	
	
	<div id="divPartidos" [style.display]="opcion == 1 ? 'block' : 'none'">
		<table id="tablePartidos" class="table table-striped" *ngIf="partidos && partidos.length > 0">
		  <thead>
		    <tr class="small">
		      <th class="nopadding text-center">Jor.</th>
		      <th class="nopadding text-center">Fecha</th>
		      <th class="nopadding text-center">Local</th>
		      <th class="nopadding text-center">Visitante</th>
		      <th class="nopadding text-center">Resultado</th>
		    </tr>
		  </thead>
		  <tbody class="small">
		    <tr *ngFor="let partido of partidos let index = index">
		      <td class="nopadding text-center align-middle">{{partido.idPartido}}</td>
		      <td class="nopadding align-middle">{{partido.fecha | date:'dd/MM'}} {{partido.hora}}</td>
		      <td class="nopadding align-middle"
		         [style.font-weight]="partido.equipoLocal.includes('ALUCHE') ? 'bold' : 'normal'">{{partido.equipoLocal}}</td>
		      <td class="nopadding align-middle"
		         [style.font-weight]="partido.equipoVisitante.includes('ALUCHE') ? 'bold' : 'normal'">{{partido.equipoVisitante}}</td>
		      <td class="nopadding text-center align-middle"
		         [style.color]="partido.resultado == 'SUSPENDIDO' ? 'red' : 'black'">{{partido.resultado}}</td>
		    </tr>
		  </tbody>
		</table>
	</div>
	
	<div id="divClasificacion" [style.display]="opcion == 2 ? 'block' : 'none'">
		<table id="tableClasificacion" class="table table-striped" *ngIf="clasificaciones && clasificaciones.length > 0">
		  <thead>
		    <tr class="small">
		      <th class="nopadding text-center" colspan="2"></th>
		      <th class="nopadding text-center">PT</th>
		      <th class="nopadding text-center">PJ</th>
		      <th class="nopadding text-center">PG</th>
		      <th class="nopadding text-center">PE</th>
		      <th class="nopadding text-center">PP</th>
		      <th class="nopadding text-center">GF</th>
		      <th class="nopadding text-center">GC</th>
		      <th class="nopadding text-center">Gav</th>
		    </tr>
		  </thead>
		  <tbody class="small">
		        <tr *ngFor="let clasificacion of clasificaciones let index = index"
		         [style.font-weight]="clasificacion.equipo.includes('ALUCHE') ? 'bold' : 'normal'">
		          <td class="nopadding text-center align-middle">{{clasificacion.posicion}}</td>
		          <td class="nopadding align-middle">{{clasificacion.equipo}}</td>
		          <td class="nopadding text-center align-middle">{{clasificacion.puntos}}</td>
		          <td class="nopadding text-center align-middle">{{clasificacion.partidosJugados}}</td>
		          <td class="nopadding text-center align-middle">{{clasificacion.partidosGanados}}</td>
		          <td class="nopadding text-center align-middle">{{clasificacion.partidosEmpatados}}</td>
		          <td class="nopadding text-center align-middle">{{clasificacion.partidosPerdidos}}</td>
		          <td class="nopadding text-center align-middle">{{clasificacion.golesAFavor}}</td>
		          <td class="nopadding text-center align-middle">{{clasificacion.golesEnContra}}</td>
		          <td class="nopadding text-center align-middle">{{clasificacion.golAverage}}</td>
		        </tr>
		  </tbody>
		</table>
	</div>
</div>